import type { HTMLAttributes, ReactNode } from 'react'

import { Icon } from './Icon'
import styles from './VideoLightbox.module.css'

export interface VideoLightboxProps extends Omit<HTMLAttributes<HTMLElement>, 'children'> {
  src: string
  poster?: string
  currentLabel?: string
  durationLabel: string
  progress?: number
  children: ReactNode
}

function assetUrl(path: string | undefined): string | undefined {
  if (!path || path.startsWith('/') || path.startsWith('data:')) return path
  return `/${path}`
}

export function VideoLightbox({
  src,
  poster,
  currentLabel = '0:00',
  durationLabel,
  progress = 0,
  children,
  className = '',
  ...props
}: VideoLightboxProps) {
  const clampedProgress = Math.max(0, Math.min(1, progress))
  return (
    <section data-component="video-lightbox" className={`${styles.lightbox} ${className}`} {...props}>
      <div className={styles.figure}>
        <video data-context="video-media" src={assetUrl(src)} poster={assetUrl(poster)} autoPlay muted loop playsInline preload="metadata" />
        <div className={styles.controls}>
          <Icon name="play" size={18} strokeWidth={2} />
          <span className={styles.time}>{currentLabel} / {durationLabel}</span>
          <div className={styles.bar}><i style={{ width: `${clampedProgress * 100}%` }} /></div>
          <span>静音循环</span>
        </div>
      </div>
      <aside className={styles.side}>{children}</aside>
    </section>
  )
}

export interface VideoLightboxFieldProps {
  label: string
  children: ReactNode
}

export function VideoLightboxField({ label, children }: VideoLightboxFieldProps) {
  return <div><p className={styles.key}>{label}</p><p className={styles.value}>{children}</p></div>
}

export function VideoLightboxFooter({ children }: { children: ReactNode }) {
  return <div className={styles.footer}>{children}</div>
}
